import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavigationService } from './services/navigation.service';
import { ThemeService } from './services/theme.service';
import { RoutePartsService } from './services/route-parts.service';
import { AuthGuard } from './services/guard/auth.guard';
import { ItrGuard } from './services/guard/itr.guard';
import { ResidentGuard } from './services/guard/resident.guard';

import { SharedComponentsModule } from './components/shared-components.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';

@NgModule({
	imports: [CommonModule, SharedComponentsModule, SharedDirectivesModule],
	providers: [NavigationService, ThemeService, RoutePartsService, AuthGuard, ItrGuard, ResidentGuard],
	exports: [SharedComponentsModule, SharedDirectivesModule],
})
export class SharedModule { }
